<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelect
                      style='width: 200px'
                      title='选择用户'
                      labelName='userName'
                      labelValue='id'
                      :value='queryForm.userId'
                      :limit='1'
                      size='small'
                      placeholder='请选择用户'
                      @getValue='getSearchValueUserId'
                      :columns="USER_code"
                      :searchs="USER_search"
                      dataListUrl='/mpp/user/findList'
                      entityBeanName='mppUser'
                      queryEntityUrl='/mpp/user/get'
                  >
                  </GridSelect>
              </el-form-item>
              <el-form-item label="金额">
                  <el-input style='width: 200px' v-model="queryForm.money"></el-input>
              </el-form-item>
              <el-form-item label="是否发放">
<!--                  <el-input style='width: 200px' v-model="queryForm.isSend"></el-input>-->
                  <el-select
                      placeholder='请选择是否发放'
                      clearable
                      style='width: 200px'
                      size='small'
                      v-model='queryForm.isSend'
                  >
                      <el-option
                          label='是'
                          :value='1'
                      >
                      </el-option>
                      <el-option
                          label='否'
                          :value='0'
                      >
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="相关编号">
                  <el-input style='width: 200px' v-model="queryForm.relatedNo"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopIncomeCultivateList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopIncomeCultivate"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopIncomeCultivate(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopIncomeCultivate(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportShopIncomeCultivateList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshShopIncomeCultivateList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopIncomeCultivateList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope" v-if='scope.row.user'>
              <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
              <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
              <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
              <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="money"
        label="金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isSend"
        label="是否发放"
        width="180"
      >
          <template slot-scope="scope">
              {{ scope.row.isSend == 1 ? '是' : '否' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="detail"
        label="记录明细"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="relatedNo"
        label="相关编号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopIncomeCultivate(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editShopIncomeCultivate(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteShopIncomeCultivate(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopIncomeCultivateStates[shopIncomeCultivateState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopIncomeCultivate"
          ref="shopIncomeCultivateForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopIncomeCultivate.userId"-->
<!--              :disabled="shopIncomeCultivateState == 'check'"-->
<!--            ></el-input>-->
              <GridSelect
                  style='width: 200px'
                  title='选择用户'
                  labelName='userName'
                  labelValue='id'
                  :disabled="shopIncomeCultivateState == 'check'"
                  :value='shopIncomeCultivate.userId'
                  :limit='1'
                  size='small'
                  placeholder='请选择用户'
                  @getValue='getValueUserId'
                  :columns="USER_code"
                  :searchs="USER_search"
                  dataListUrl='/mpp/user/findList'
                  entityBeanName='mppUser'
                  queryEntityUrl='/mpp/user/get'
              >
              </GridSelect>
          </el-form-item>
          <el-form-item
            label="金额"
            prop="money"
          >
            <el-input
              size="small"
              style='width: 200px'
              v-model="shopIncomeCultivate.money"
              :disabled="shopIncomeCultivateState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否发放"
            prop="isSend"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 200px'-->
<!--              v-model="shopIncomeCultivate.isSend"-->
<!--              :disabled="shopIncomeCultivateState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  placeholder='请选择是否发放'
                  clearable
                  style='width: 200px'
                  size='small'
                  v-model='shopIncomeCultivate.isSend'
                  :disabled="shopIncomeCultivateState == 'check'"
              >
                  <el-option
                      label='是'
                      :value='1'
                  >
                  </el-option>
                  <el-option
                      label='否'
                      :value='0'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="记录明细"
            prop="detail"
          >
            <el-input
              size="small"
              style='width: 200px'
              v-model="shopIncomeCultivate.detail"
              :disabled="shopIncomeCultivateState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="相关编号"
            prop="relatedNo"
          >
            <el-input
              size="small"
              style='width: 200px'
              v-model="shopIncomeCultivate.relatedNo"
              :disabled="shopIncomeCultivateState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopIncomeCultivateState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { USER, USER_SEARCH } from '@/utils/constant';
import GridSelect from '@/components/gridselect/index.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopIncomeCultivateList();
                    this.getShopIncomeCultivateList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopIncomeCultivateList();
                    this.getShopIncomeCultivateList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户id
                     money: '', //金额
                     isSend: '', //是否发放
                     detail: '', //记录明细
                     relatedNo: '', //相关编号
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopIncomeCultivateState: 'add',
                shopIncomeCultivateStates: {
                    add: '新建培育明细',
                    check: '查看培育明细',
                    edit: '修改培育明细'
                },

                multipleSelection: [],
                shopIncomeCultivateList: [],
                shopIncomeCultivate: {
                    id: '', //主键
                    userId: '', //用户id
                    money: '', //金额
                    isSend: '', //是否发放
                    detail: '', //记录明细
                    relatedNo: '', //相关编号
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户id不能为空', trigger: 'blur' }],
                    money: [{ required: true, message: '金额不能为空', trigger: 'blur' }],
                    isSend: [{ required: true, message: '是否发放不能为空', trigger: 'blur' }],
                    detail: [{ required: true, message: '记录明细不能为空', trigger: 'blur' }],
                    relatedNo: [{ required: true, message: '相关编号不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getShopIncomeCultivateList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getSearchValueUserId(value) {
                this.queryForm.userId = value;
            },
            getValueUserId(value) {
                this.shopIncomeCultivate.userId = value;
            },
            resetShopIncomeCultivateList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopIncomeCultivateList = [];
            },
            resetDialog() {
                this.shopIncomeCultivateState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户id
                      money: '', //金额
                      isSend: '', //是否发放
                      detail: '', //记录明细
                      relatedNo: '', //相关编号
                };
                this.getShopIncomeCultivateList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopIncomeCultivate = {
                      id: '', //主键
                      userId: '', //用户id
                      money: '', //金额
                      isSend: '', //是否发放
                      detail: '', //记录明细
                      relatedNo: '', //相关编号
                };
            },
            submitForm() {
                if (this.shopIncomeCultivateState == 'add') {
                    this.$refs.shopIncomeCultivateForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/incomecultivate/add`,{ ...this.shopIncomeCultivate }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopIncomeCultivateList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopIncomeCultivateState == 'edit') {
                    this.$refs.shopIncomeCultivateForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/incomecultivate/edit`,{ ...this.shopIncomeCultivate }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopIncomeCultivateList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopIncomeCultivate() {
                this.showDialog = true;
                this.shopIncomeCultivateState = 'add';
            },
            checkShopIncomeCultivate(shopIncomeCultivateId) {
                console.log(shopIncomeCultivateId);
                this.currentShopIncomeCultivateId = shopIncomeCultivateId;

                this.getShopIncomeCultivateById();
                this.showDialog = true;
                this.shopIncomeCultivateState = 'check';
            },
            editShopIncomeCultivate(shopIncomeCultivateId) {
                console.log('shopIncomeCultivate', shopIncomeCultivateId);
                if (shopIncomeCultivateId) {
                    this.currentShopIncomeCultivateId = shopIncomeCultivateId;
                    this.getShopIncomeCultivateById();
                } else {
                    this.shopIncomeCultivate = { ...this.shopIncomeCultivate, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopIncomeCultivateState = 'edit';
            },
            deleteShopIncomeCultivate(shopIncomeCultivateId) {
                let ids = '';
                if (shopIncomeCultivateId) {
                    ids = shopIncomeCultivateId;
                } else {
                    ids = this.multipleSelection.map((shopIncomeCultivate) => shopIncomeCultivate.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/incomecultivate/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopIncomeCultivateList();
                                this.getShopIncomeCultivateList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopIncomeCultivateList() {
                this.resetShopIncomeCultivateList();
                this.getShopIncomeCultivateList();
            },
            getShopIncomeCultivateList(query = {}) {
                this.loading = true;
                get(`/shop/incomecultivate/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopIncomeCultivateList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopIncomeCultivateById() {
                get(`/shop/incomecultivate/get`,{ id: this.currentShopIncomeCultivateId }).then((res) =>{
                    if(res.success){
                      this.shopIncomeCultivate = { ...this.shopIncomeCultivate, ...res.shopIncomeCultivate };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopIncomeCultivateList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/incomecultivate/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/incomecultivate/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/incomecultivate/importData`,formData);
              this.refreshShopIncomeCultivateList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopIncomeCultivateList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopIncomeCultivateList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>